var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"empty-messagebox"}},[_c('div',{staticClass:"container-fluid card-info message-card mb-3 mt-4"},[_c('h6',{staticClass:"pt-2"},[_vm._v(_vm._s(_vm.$t('no-results-found')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }